import React from 'react';
import { getStaticUrl } from '../../../../utils/img';

const Loading = () => (
  <img src={getStaticUrl('web/v1/img/loaders/loader1.gif')} />
);

export default Loading;
